<template>
  <div :class="`${classes} dnd-item`">
    <slot />
    <slot v-handle name="handle" />
  </div>
</template>

<script>
import { ElementMixin, HandleDirective } from 'vue-slicksort';
export default {
  name: 'SortableItem',
  directives: { handle: HandleDirective },
  mixins: [ElementMixin],
  props: ['classes']
};
</script>

<style scoped>
.dnd-item {
  z-index: 1000 !important;
  font-family: 'Roboto';
  background-color: white;
  width: 100%;
}
</style>
